import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { finalize, share, map, catchError } from 'rxjs/operators';
import { jwtDecode } from 'jwt-decode';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  apiURL = environment.apiURL;
  private refreshing$?: Observable<any>;
  // apiURL = '';
  constructor(private http: HttpClient,private storageService : StorageService) {}

  sendOtp(mobile_number: string): Observable<any> {
    const token = this.storageService.getItem('guest_token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    return this.http.post(
      `${this.apiURL}/api/send-otp`,
      { mobile_number }, 
      { headers }
    );
  }

  adminLoginAsUser(mobile_number: string): Observable<any> {
    const token = this.storageService.getItem('guest_token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    return this.http.post(
      `${this.apiURL}/api/auth/admin-login-as-user`,
      { mobile_number }, 
      { headers }
    );
  }


  createUser(userData: { mobile_number: string, role: string, name?: string, email_id?: string, status: string }): Observable<any> {
    return this.http.post(`${this.apiURL}/api/users/`, userData);
  }

  verifyOtp(mobile_number: string, otp: string): Observable<any> {
    return this.http.post(`${this.apiURL}/api/verify-otp`, { mobile_number, otp },{ withCredentials: true });
  }

  register(userData: any): Observable<any> {
    return this.http.post(`${this.apiURL}/api/auth/register`, userData);
  }

  // sendOtpInWhatsapp(number: string): Observable<any> {
  //   return this.http.post(`${this.apiURL}/api/send_messageOnwhatsapp`, number);
  // }

  // checkPresentOrNot(number?: string): Observable<any> {
  //   return this.http.post(`${this.apiURL}/api/users/check-existence`, number);
  // }

  logout(): Observable<any> {
    return this.http.post(
      `${this.apiURL}/api/auth/logout`,
      {},
      { withCredentials: true }
    ).pipe(
      finalize(() => {
        this.storageService.clear();
      })
    );
  }

  getUser(): Observable<any> {
    return this.http.get(`${this.apiURL}/me`, { withCredentials: true });
  }

  refreshToken(): Observable<any> {
    if (this.refreshing$) {
      return this.refreshing$;
    }

    // console.log(`[AuthService] Calling /api/auth/refresh... Check network tab to verify if refresh token cookie is sent`);

    this.refreshing$ = this.http.post(
      `${this.apiURL}/api/auth/refresh`,
      {},
      { withCredentials: true, observe: 'response' } // observe full response to log status code
    ).pipe(
      map((response: any) => {
        // console.log(`[AuthService] Refresh API returned status code: ${response.status}`);
        return response.body;
      }),
      catchError((error) => {
        console.error(`[AuthService] Refresh API failed. Status: ${error.status}, Exact error response:`, error.error);
        throw error;
      }),
      finalize(() => {
        this.refreshing$ = undefined;
      }),
      share()
    );

    return this.refreshing$;
  }

  ///////////////// token

  decodeToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch (error) {
      console.error('Invalid token', error);
      return null;
    }
  }

  getIdFromToken(token: string): number | null {
    const decoded = this.decodeToken(token);
    return decoded || null;
  }
}
